import { RouterProvider } from "react-router-dom";
import { appRouter } from "./routes";
import { Provider } from "react-redux";
import { store } from "./store/reducer";
import React from "react";
import { createRoot } from "react-dom/client";

function App() {
  return (
    <Provider store={store}>
      <RouterProvider router={appRouter} />
    </Provider>
  );
}

// Funksjon for å montere appen til DOM
function renderApp() {
  const container = document.getElementById("main-content-wrapper");
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  }
}

// Start MSW i development mode og vent før app rendres
if (import.meta.env.DEV) {
  import("./mocks/browser")
    .then(({ worker }) =>
      worker.start({
        onUnhandledRequest: "bypass",
      }),
    )
    .then(() => renderApp());
} else {
  renderApp();
}

export default App;
